import { api } from '@cma/app'
import {
  PlatformClientQuery,
  PlatformClientQueryVariables
} from '@cma/generated/graphql'
import { useQuery } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function usePlatformClient(variables: PlatformClientQueryVariables) {
  return useQuery<PlatformClientQuery, Error>(
    ['platformClient', variables],
    () => {
      const query = gql`
        query PlatformClient($id: ID!) {
          platformClient(id: $id) {
            id
            platformAccountName
            usersCount
            shareableTargets {
              brokerageId
              primaryOfficeId
              entityId
              entityType
              name
              usersCount
            }
            brokerages {
              id
              name
              offices {
                id
                brokerageId
                name
                usersCount
                displayAddress
              }
              displayAddress
              usersCount
            }
            offices {
              id
              brokerageId
              name
              usersCount
              displayAddress
            }
            teams {
              emailAddress
              id
              name
              phoneNumber
              platformTeamId
              primaryOfficeId
              primaryOfficePlatformId
              usersCount
              primaryOffice {
                brokerageId
                displayAddress
                id
                name
                usersCount
              }
            }
            brandings {
              brandableId
              brandableType
              editable
              inherited
              branding {
                brandableId
                brandableType
                createdAt
                createdBy
                hasLogo
                id
                locked
                logoContentType
                logoFileName
                logoFileSize
                logoThumbnailUrl
                logoUpdatedAt
                logoUrl
                secondaryLogoUrl
                name
                primaryColor
                primaryFont
                published
                secondaryColor
                secondaryFont
                updatedAt
                creator {
                  name
                }
              }
            }
            defaultFonts {
              key
              value
              url
            }
          }
        }
      `
      return api<PlatformClientQuery, PlatformClientQueryVariables>({
        query,
        variables
      })
    },
    {
      enabled: !!variables.id
    }
  )
}
